import React, { SyntheticEvent } from 'react'
import { Button } from 'antd';
import commonStyles from '../../components/CSIComponents/index.module.css';

type propTypes = {
  setIsOnEdit: () => void
  update: () => void
  disableFlag: boolean
  onDelete?: (() => void) | ((e: SyntheticEvent) => void)  | (() => Promise<void>) | false
  disableDelete?: boolean
}

const CSIActionsButtonsComponent = (props: propTypes) => {

  const {onDelete = false} = props
  return(
    <div
     className={commonStyles['opertaion-wrap']}
     style={{ left: window.rightContentWidth }}
    >
      <div className='action-buttons-content'>
      {onDelete && (
          <Button danger type='primary' onClick={onDelete} disabled={props.disableDelete}>
            Delete
          </Button>
        )}
      <div className='actions-separator' />

      <Button
        className="db-mr-10"
        onClick={() => { 
          props.setIsOnEdit() 
        }}>
        Cancel
      </Button>
      <Button
        type='primary'
        onClick={props.update}
        disabled={props.disableFlag} >
        Save
      </Button>
      </div>
      
    </div>
  )
}

export default CSIActionsButtonsComponent
